import React from "react";

import JRstreet from "../Images/juststreet.jpg";
import JR from "../Images/JR.png";



export default function JRStreet() {
    return <div className="Section sFour" style={{ backgroundImage: `url(${JRstreet})` }}>
                <img loading="lazy" className="JRlogo" src={JR} />
            </div>
}